module.exports = __webpack_public_path__ + "static/media/luggages1.34876a62.jpg";